import AdminBookingsTable from '@website/components/admin/AdminBookings/AdminBookingsTable';
import AdminLayout from '../../components/layouts/adminLayout';

export default function BookingsPage() {
  return (
    <AdminLayout>
      <div className="mt-4">
        <AdminBookingsTable />
      </div>
    </AdminLayout>
  );
}
